import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
import mdaeNotfy, { NOTIFY_MESSAGE_TYPE } from "../../../../common_components/common_widgets/toast/notify";
import { getDefaultOptions } from "../../../../utils/fetch";
export const DELETE_DENIAL_REASONS = "DELETE_DENIAL_REASONS";

export const service = async (data) => {
  const options: object = {
    url: `/Api/DenialReasons/DeleteDenialReasons`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };

  const response = await callMvcApi(options);
  if (response !== 0) {
    mdaeNotfy({ message: data.denialReasonName + " Deleted Succesfully!", messageType: NOTIFY_MESSAGE_TYPE.SUCCESS })
  }
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(DELETE_DENIAL_REASONS, service, mock);
